import classNames from 'classnames';
import React, { useMemo } from 'react';
import { useDynamicImage } from '../../../hooks/useDynamicImage';

export const ClothReward = ({ clothes }) => {
  const formattedPrize = useMemo(
    () =>
      clothes.reduce(
        (acc, imgSrc, index) => ({
          ...acc,
          [`shopItem${index ? index + 1 : ''}`]: { preview_image: imgSrc },
        }),
        {},
      ),
    [clothes],
  );

  const { activeImage, imgRef } = useDynamicImage({ prize: formattedPrize });

  return (
    <div className={classNames('reward')}>
      <div className={'reward__icon'}>
        <img ref={imgRef} src={activeImage} alt={''} />
      </div>
    </div>
  );
};
